export const IN_APP_BROWSER_UA = {
  FACEBOOK: /fban|fbav|fb_iab|fbios|fb4a/i,
  PIXEL: /\bpixel(?:\s|[;)/]|$)/i,
  TIKTOK: /tiktok|appname\/trill|trill_[0-9_]+|musical_ly/,
  ANDROID: /android/,
  ANDROID_WEBVIEW: /\bwv\b/,
  SNAPCHAT: /snapchat|snapchatads/,
  SNAP_KIT: /snap kit|snapkit/,
  SNAP: /\bsnap/,
} as const;
